import styled from 'styled-components';

export const StyledTimeline = styled.div`
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: calc(1em);
    bottom: 0;
    width: 2px;
    background-color: #f0f0f0;
  }
`;

export const StyledTimelineItem = styled.div`
  position: relative;
  padding-bottom: 2px;

  &::before {
    content: '';
    position: absolute;
    left: -15px;
    top: calc(1em);
    transform: translateY(-50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #138296; // KatToggle component's color, scraped from inspect element ;)
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #138296;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const StyledEmpty = styled.div`
  text-align: center;
  padding: 40px 0;
  color: #999;
`;
